import React, {createContext, useContext, useState, useEffect} from 'react';
import {toast} from 'react-hot-toast';
import useLocalStorage from '../hooks/useLocalStorage';
import lang from "../JSON-FILES/lang.json"

const Context = createContext();

/**
 *  #context
 * ManagementContext is a context that provides the state of the management page.
 * It provides the state of the new customer product, new supply customer product, new non conformity, new presidio module, new register template, new register duplicating doc, new user, new client, new site, new list, new field and the edited versions of them.
 * It also provides the default offer menu and default register menu.
 * The state of the management page is stored in the local storage.
 */
export const ManagementContext = ({children}) => {

    const [newCustomerProduct, setNewCustomerProduct] = useLocalStorage("newCustomerProduct")
    const [newCustomerProductEdited, setNewCustomerProductEdited] = useLocalStorage("newCustomerProductEdited")

    const [newSupplyCustomerProduct, setNewSupplyCustomerProduct] = useLocalStorage("newSupplyCustomerProduct")
    const [newSupplyCustomerProductEdited, setNewSupplyCustomerProductEdited] = useLocalStorage("newSupplyCustomerProductEdited")

    const [newNonConformity, setNewNonConformity] = useLocalStorage("newNonConformity")
    const [newNonConformityEdited, setNewNonConformityEdited] = useLocalStorage("newNonConformityEdited")

    const [newRegisterTemplate, setNewRegisterTemplate] = useLocalStorage("newRegisterTemplate")
    const [newRegisterTemplateEdited, setNewRegisterTemplateEdited] = useLocalStorage("newRegisterTemplateEdited")
    const [newRegisterDuplicatingDoc, setNewRegisterDuplicatingDoc] = useLocalStorage("newRegisterDuplicatingDoc")

    const [newPresidioModule, setNewPresidioModule] = useLocalStorage("newPresidioModule")
    const [newPresidioModuleEdited, setNewPresidioModuleEdited] = useLocalStorage("newPresidioModuleEdited")

    const [newUser, setNewUser] = useLocalStorage("newUser")
    const [newUserEdited, setNewUserEdited] = useLocalStorage("newUserEdited")

    const [newClient, setNewClient] = useLocalStorage("newClient")
    const [newClientEdited, setNewClientEdited] = useLocalStorage("newClientEdited")

    const [newSite, setNewSite] = useLocalStorage("newSite")
    const [newSiteEdited, setNewSiteEdited] = useLocalStorage("newSiteEdited")

    const [newList, setNewList] = useLocalStorage("newList")
    const [newListEdited, setNewListEdited] = useLocalStorage("newListEdited")

    const [newField, setNewField] = useLocalStorage("newField")
    const [newFieldEdited, setNewFieldEdited] = useLocalStorage("newFieldEdited")

    const [defaultOfferMenu, setDefaultOfferMenu] = useLocalStorage("defaultOfferMenu")
    const [defaultRegisterMenu, setDefaultRegisterMenu] = useLocalStorage("defaultRegisterMenu")


    return (
        <Context.Provider
            value={{
                defaultOfferMenu,
                setDefaultOfferMenu,
                defaultRegisterMenu,
                setDefaultRegisterMenu,
                newCustomerProduct, 
                setNewCustomerProduct,
                newCustomerProductEdited, 
                setNewCustomerProductEdited,
                newSupplyCustomerProduct, 
                setNewSupplyCustomerProduct,
                newSupplyCustomerProductEdited, 
                setNewSupplyCustomerProductEdited,
                newNonConformity, 
                setNewNonConformity,
                newNonConformityEdited, 
                setNewNonConformityEdited,
                newPresidioModule, 
                setNewPresidioModule,
                newPresidioModuleEdited, 
                setNewPresidioModuleEdited,
                newRegisterTemplate, 
                setNewRegisterTemplate,
                newRegisterTemplateEdited, 
                setNewRegisterTemplateEdited,
                newRegisterDuplicatingDoc, 
                setNewRegisterDuplicatingDoc,
                newUser, 
                setNewUser,
                newUserEdited, 
                setNewUserEdited,
                newClient, 
                setNewClient,
                newClientEdited, 
                setNewClientEdited,
                newSite, 
                setNewSite,
                newSiteEdited, 
                setNewSiteEdited,
                newList, 
                setNewList,
                newListEdited, 
                setNewListEdited,
                newField, 
                setNewField,
                newFieldEdited, 
                setNewFieldEdited
            }}>
            {children}
        </Context.Provider>
    )
}

export const useManagementContext = () => useContext(Context);


